import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

interface SaveIpfNewVersionCommand {
  version: string;
}

export const saveIpfNewVersion: GlobalStateCommandFactory<
  SaveIpfNewVersionCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.ipfNewVersion = command.version;
  });
};
